import React, { Fragment } from 'react'
import { isToday, isEqual, format, addDays } from 'date-fns'

const DayPicker = ({
  classname,
  today,
  todaysDate,
  selectedDate,
  futureDays,
  onChangeDay,
  locationId
}) => (
  <div className={`${classname} dayPickerBanner`}>
    <div className="tabs">
      <button
        className={
          today && isEqual(todaysDate, selectedDate) ? 'link active' : 'link'
        }
        onClick={() =>
          selectedDate !== todaysDate && onChangeDay(todaysDate, locationId)
        }
      >
        Today
      </button>
    </div>
    {futureDays.map(day => {
      return (
        <div className="tabs" key={day.dayLabel}>
          <button
            onClick={() =>
              selectedDate !== day.selectedDate &&
              onChangeDay(day.selectedDate, locationId)
            }
            className={
              selectedDate === day.selectedDate ? 'link active' : 'link'
            }
          >
            {day.dayLabel}
          </button>
        </div>
      )
    })}
  </div>
)

const DayPickerWrapper = ({
  onChangeDay,
  todaysDate = format(new Date(), 'MM/DD/YYYY'),
  selectedDate,
  locationId
}) => {
  const today = isToday(todaysDate)
  let futureDays = []
  let shortenFutureDays = []

  for (let i = 1; i <= 5; i++) {
    let date = addDays(todaysDate, i)
    futureDays.push({
      dayLabel: format(date, 'dddd'),
      selectedDate: format(date, 'YYYYMMDD')
    })
  }

  for (let i = 1; i <= 5; i++) {
    let date = addDays(todaysDate, i)
    shortenFutureDays.push({
      dayLabel: format(date, 'ddd'),
      selectedDate: format(date, 'YYYYMMDD')
    })
  }

  return (
    <Fragment>
      <DayPicker
        classname="mobile"
        today={today}
        todaysDate={todaysDate}
        selectedDate={selectedDate}
        futureDays={shortenFutureDays}
        onChangeDay={onChangeDay}
        locationId={locationId}
      />
      <DayPicker
        classname="tablet"
        today={today}
        todaysDate={todaysDate}
        selectedDate={selectedDate}
        futureDays={shortenFutureDays}
        onChangeDay={onChangeDay}
        locationId={locationId}
      />
      <DayPicker
        classname="desktop"
        today={today}
        todaysDate={todaysDate}
        selectedDate={selectedDate}
        futureDays={futureDays}
        onChangeDay={onChangeDay}
        locationId={locationId}
      />
    </Fragment>
  )
}

export default DayPickerWrapper
